// Impeccable (optimize, 10/10): a cada tecla no código, o editor lia o YAML inteiro umas sete vezes
// (o nome do flow, a documentação sob o cursor, os nós do canvas, os params do teste, os erros de
// fórmula, o passo sob o cursor), cada função com o seu `parseDocument`. Medido: 1 a 2 ms por leitura
// com 60 a 130 linhas, e cresce com o flow.
//
// Aqui a leitura acontece uma vez por versão do texto, e quem só LÊ o documento a compartilha. Quem
// EDITA (definir um valor, renomear, inserir um passo) continua lendo o seu, porque mexe nele, e um
// documento compartilhado alterado seria o texto de outra pessoa.
import { LineCounter, parseDocument } from 'yaml';

// Poucas versões bastam: a de agora, a de antes (o canvas e o código podem estar um passo atrás) e a
// do rascunho salvo.
const GUARDADOS = 4;
const lidos = new Map();

// `{doc, contador}`: o documento e o contador de linhas dele, para quem precisa da linha de um nó.
// O documento é só para LER: não o altere.
export function documentoLido(texto) {
  const guardado = lidos.get(texto);
  if (guardado) {
    lidos.delete(texto);
    lidos.set(texto, guardado);
    return guardado;
  }
  const contador = new LineCounter();
  const lido = {
    doc: parseDocument(texto, { lineCounter: contador }),
    contador,
  };
  lidos.set(texto, lido);
  if (lidos.size > GUARDADOS) lidos.delete(lidos.keys().next().value);
  return lido;
}

// O mesmo que o `parse` do pacote `yaml`: o objeto, ou o primeiro erro lançado.
export function objetoLido(texto) {
  const { doc } = documentoLido(texto);
  if (doc.errors.length) throw doc.errors[0];
  return doc.toJS();
}
